'use strict';

exports.__esModule = true;
exports.BasicInput = exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _connectField = require('./connectField');

var _connectField2 = _interopRequireDefault(_connectField);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Field = function (_Component) {
  (0, _inherits3.default)(Field, _Component);

  function Field() {
    (0, _classCallCheck3.default)(this, Field);
    return (0, _possibleConstructorReturn3.default)(this, _Component.apply(this, arguments));
  }

  Field.prototype.render = function render() {
    var _props = this.props,
        name = _props.name,
        component = _props.component;

    var FieldInput = (0, _connectField2.default)(name, this.props)(component || BasicInput);

    return _react2.default.createElement(FieldInput, null);
  };

  return Field;
}(_react.Component);

Field.propTypes = {
  component: _react.PropTypes.object,
  name: _react.PropTypes.string.isRequired
};
exports.default = Field;

var BasicInput = exports.BasicInput = function (_Component2) {
  (0, _inherits3.default)(BasicInput, _Component2);

  function BasicInput() {
    (0, _classCallCheck3.default)(this, BasicInput);
    return (0, _possibleConstructorReturn3.default)(this, _Component2.apply(this, arguments));
  }

  BasicInput.prototype.render = function render() {
    var _props2 = this.props,
        label = _props2.label,
        error = _props2.error;


    return _react2.default.createElement(
      'div',
      null,
      label && _react2.default.createElement(
        'label',
        null,
        label
      ),
      _react2.default.createElement('input', (0, _extends3.default)({ type: 'text' }, this.props)),
      error && _react2.default.createElement(
        'div',
        { className: 'error' },
        error
      )
    );
  }; // eslint-disable-line


  return BasicInput;
}(_react.Component);

BasicInput.propTypes = {
  error: _react.PropTypes.string,
  label: _react.PropTypes.string
};


//////////////////
// WEBPACK FOOTER
// ./~/onion-form/lib/Field.react.js
// module id = 974
// module chunks = 0